import React, { useEffect } from "react";
import { createPortal } from "react-dom";

const BASE_URL = process.env.REACT_APP_EXPRESS_API_BASE_URL || "http://localhost:3001";

export function resolveMediaImg(url) {
  if (!url) return null;
  if (url.startsWith("/uploads/")) return `${BASE_URL}${url}`;
  return url;
}

// media = { img, title, description, link }
const MediaDetailModal = ({ media, onClose }) => {
  useEffect(() => {
    const handler = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", handler);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", handler);
      document.body.style.overflow = "";
    };
  }, [onClose]);

  if (!media) return null;
  const src = resolveMediaImg(media.img);

  return createPortal(
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center p-4"
      onClick={onClose}
    >
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" />

      {/* Modal */}
      <div
        className="relative z-10 bg-zinc-900 border border-zinc-700 rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 z-20 w-8 h-8 flex items-center justify-center rounded-full bg-zinc-800 hover:bg-zinc-700 text-zinc-400 hover:text-white transition-colors text-sm"
        >
          ✕
        </button>

        {/* Image */}
        {src && (
          <div className="w-full bg-zinc-950">
            <img
              src={src}
              alt={media.title || ""}
              className="w-full max-h-72 object-cover"
            />
          </div>
        )}

        {/* Content */}
        <div className="p-5">
          {media.title && (
            <h3 className="text-white font-bold text-base leading-snug mb-2">{media.title}</h3>
          )}
          {media.description && (
            <p className="text-zinc-400 text-sm leading-relaxed mb-4">{media.description}</p>
          )}
          {media.link && (
            <a
              href={media.link}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold rounded-xl transition-colors"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                  d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
              </svg>
              Buka Link
            </a>
          )}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default MediaDetailModal;
